// Radha — light/dark toggle. Sets data-theme on <html> (which flips the tokens
// in theme.css) and persists the choice. With no stored choice the app follows
// the OS via prefers-color-scheme; picking here forces one and remembers it.
import React, { useState } from "react";

const KEY = "radha.theme";

function osPrefersDark() {
  return typeof window !== "undefined"
    && window.matchMedia?.("(prefers-color-scheme: dark)").matches;
}

export function ThemeToggle({ className }: { className?: string } = {}) {
  const [forced, setForced] = useState<string | null>(
    () => (typeof document !== "undefined" && document.documentElement.dataset.theme) || null,
  );
  const effective = forced ?? (osPrefersDark() ? "dark" : "light");

  const set = (t: "light" | "dark") => {
    document.documentElement.dataset.theme = t;
    try { localStorage.setItem(KEY, t); } catch { /* private mode */ }
    setForced(t);
  };

  return (
    <button
      onClick={() => set(effective === "dark" ? "light" : "dark")}
      title={`Switch to ${effective === "dark" ? "light" : "dark"} theme`}
      aria-label="Toggle colour theme"
      className={className}
      style={{
        border: "1px solid var(--border)", background: "var(--surface)", color: "var(--fg-muted)",
        borderRadius: 9, width: 32, height: 30, cursor: "pointer", fontSize: 14, lineHeight: 1,
      }}
    >
      {effective === "dark" ? "☀" : "☾"}
    </button>
  );
}
